// Operations — tasks, deals, projects, calendar. The daily-work surface.

import { PageHeader, StubBanner } from '../components/Page';
import { Card, CardLabel, CardTitle } from '../components/Card';
import { T } from '../theme';

export default function Operations() {
  return (
    <>
      <PageHeader
        title="Operations"
        subtitle="Tasks, deals, projects, calendar. The daily work the studio runs on."
      />

      <StubBanner section="operations" />

      <div style={opsStyles.grid}>
        <Card>
          <CardLabel>i · Tasks</CardLabel>
          <CardTitle>Open tasks across the studio</CardTitle>
          <p style={opsStyles.muted}>
            Created from chat, briefings, or directly. Status: open, in-progress, done.
            Assignees are real people resolved through Contacts API.
          </p>
        </Card>

        <Card>
          <CardLabel>ii · Deals</CardLabel>
          <CardTitle>Active deal pipeline</CardTitle>
          <p style={opsStyles.muted}>
            Brand pitches, label conversations, partner negotiations. Stage-tracked,
            stakeholder-aware, last-touch surfaced.
          </p>
        </Card>

        <Card>
          <CardLabel>iii · Projects</CardLabel>
          <CardTitle>Multi-task umbrellas</CardTitle>
          <p style={opsStyles.muted}>
            A release, a campaign series, a partnership rollout. Owner-tracked, with
            automatic stale-detection and weekly rollups.
          </p>
        </Card>

        <Card>
          <CardLabel>iv · Calendar</CardLabel>
          <CardTitle>Meetings, deadlines, releases</CardTitle>
          <p style={opsStyles.muted}>
            Synced with Google Calendar; meeting notes auto-ingested via Gmail polling.
            Pre-meeting briefings auto-prepared from CRM context.
          </p>
        </Card>

        <Card>
          <CardLabel>v · Follow-ups</CardLabel>
          <CardTitle>What needs a nudge</CardTitle>
          <p style={opsStyles.muted}>
            Stale deals, overdue tasks, contacts gone quiet. The system schedules and
            sends nudges through the recipient's preferred channel.
          </p>
        </Card>

        <Card>
          <CardLabel>vi · Knowledge</CardLabel>
          <CardTitle>Studio memory</CardTitle>
          <p style={opsStyles.muted}>
            Persistent reference material — playbooks, vendor profiles, creative briefs,
            decisions and their reasons. Searchable, attributable.
          </p>
        </Card>
      </div>
    </>
  );
}

const opsStyles: Record<string, React.CSSProperties> = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 20,
  },
  muted: {
    fontSize: 14,
    color: T.inkSoft,
    lineHeight: 1.65,
  },
};
